import { wrapRootElement as wrap } from "./src/rootWrapper"

export const wrapRootElement = wrap
